import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ChevronRegularRightLeadReport from './chevron-regular-right-lead-report-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <ChevronRegularRightLeadReport {...props} />;
}

SvgComponent.iconName = 'chevronRegularRightLeadReport';

export const ChevronRegularRightLeadReportIcon = svgIconWrapper(SvgComponent);
